import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Spacer, Flexer, Button } from '@ontruck/orc';

import { Loading } from 'components/Loading';

import {
  IdCell,
  LoadSummaryCell,
  WeightCell,
  HeightCell,
  ExtrasSummary,
} from 'modules/Common/Details';

import GoogleMapsLink from 'modules/Common/GoogleMapsLink';

const t = {
  refresh_positions: 'Refresh positions',
  go_google: 'Go to Google Maps',
};

const ModalHeader = ({ item, idType, fetchingPositions, onRefreshClick }) => {
  if (!item) {
    return null;
  }

  const id = item.id;
  return (
    <Fragment>
      <Flexer.Parent alignItems="center" justifyContent="center">
        <Flexer.Child flexGrow="1">
          <Flexer.Parent>
            <Spacer mRight="M">
              <IdCell id={id} idType={idType} />
            </Spacer>
            <Spacer mRight="M">
              <LoadSummaryCell {...item} showMax showEquivalents />
            </Spacer>
            <Spacer mRight="M">
              <WeightCell {...item} showMax />
            </Spacer>
            <Spacer mRight="M">
              <HeightCell {...item} showMax />
            </Spacer>
            <Spacer mRight="M">
              <ExtrasSummary {...item} small />
            </Spacer>
          </Flexer.Parent>
        </Flexer.Child>

        <Flexer.Child>
          <Flexer.Parent alignItems="center">
            {!!fetchingPositions && (
              <Spacer mRight="S">
                <Loading size={20} />
              </Spacer>
            )}
            <GoogleMapsLink item={item} text={t.go_google} forceGoogleMaps />
            <Button nude disabled={fetchingPositions} onClick={onRefreshClick}>
              {t.refresh_positions}
            </Button>
          </Flexer.Parent>
        </Flexer.Child>
      </Flexer.Parent>
    </Fragment>
  );
};

ModalHeader.propTypes = {
  item: PropTypes.shape({}),
  idType: PropTypes.string,
  fetchingPositions: PropTypes.bool,
  onRefreshClick: PropTypes.func,
};

export default ModalHeader;
